// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/site_assets/fonts/AlternateGotNo1D.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/site_assets/fonts/AlternateGotNo2D.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../assets/site_assets/fonts/AlternateGotNo3D.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../assets/Generic BG Pattern Base.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../assets/site_assets/black_pattern.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Custom Fonts */
@font-face {
  font-family: 'AlternateGot';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'AlternateGot';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
  font-weight: bold;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'AlternateGot';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');
  font-weight: 300;
  font-style: normal;
  font-display: swap;
}

.app.viewer-active .header {
  justify-content: flex-start;
  padding-right: 40px;
}

.app.viewer-active .header.header-compact {
  padding-left: calc(var(--viewer-bar-width) + 24px);
  min-height: 80px;
}

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

html {
  scrollbar-gutter: stable;
}

body {
  font-family: 'AlternateGot', Arial, sans-serif;
  font-size: 18px;
  background-color: #1a1a1a;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-repeat: repeat;
  background-size: 250px 250px;
  color: #fff;
}

body.viewer-mode {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-repeat: repeat;
  background-size: 450px, 450px;
}

/* Shared layout variables */
:root {
  /* Responsive margin width: starts at 280px for large screens, scales down with viewport, then disappears */
  --viewer-bar-width: 350px;
  --viewer-stage-padding: clamp(16px, 5vw, 64px);
  /* Breakpoint where margins disappear completely */
  --margin-collapse-width: 1400px;
  /* Page margin bar width - very aggressive shrinking with viewport */
  --page-margin-width: clamp(0px, calc(25vw - 200px), 280px);
}

.app {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  padding-top: 160px; /* Increased padding between header and content */
}

.app.viewer-active {
  max-width: none;
  width: auto;
  margin: 0;
  padding: 0;
}

.app.viewer-active .container {
  min-height: 100vh;
  padding: 0;
  position: relative;
  z-index: 60;
}

.app.viewer-active .content {
  display: block;
  margin-top: 0;
  padding: 0;
  background: transparent;
}

.container {
  display: flex;
  flex-direction: column;
}

/* Header styles - removing old conflicting styles as Header.css handles this */

/* Old nav styles removed - using new Header.css styles */

/* Content styles */
.content {
  display: flex;
  margin-top: 20px;
  position: relative;
}

.viewer-bar {
  position: fixed;
  top: 0;
  bottom: 0;
  width: var(--viewer-bar-width);
  background: linear-gradient(180deg, #000 0%, #050505 100%);
  box-shadow: inset 0 0 30px rgba(0, 0, 0, 0.6);
  z-index: 40;
  pointer-events: none;
}

/* Black bar visibility is now handled by conditional rendering in App.js */

.viewer-bar-left {
  left: 0;
}

.viewer-bar-right {
  right: 0;
}

/* Hide margins completely below 900px */
@media (max-width: 900px) {
  .viewer-bar {
    width: 0;
    display: none;
  }
}

/* ===================================
   Page Margin Bars (Non-Viewer Pages)
   =================================== */
.page-margin-bar {
  position: fixed;
  top: 0;
  bottom: 0;
  /* Responsive width: starts at 280px, scales down with viewport */
  width: clamp(0px, calc(15vw - 50px), 280px);
  background: linear-gradient(180deg, #000 0%, #050505 100%);
  box-shadow: inset 0 0 30px rgba(0, 0, 0, 0.6);
  z-index: 40;
  pointer-events: none;
  transition: width 0.3s ease;
}

.page-margin-bar-left {
  left: 0;
}

.page-margin-bar-right {
  right: 0;
}

/* Responsive behavior for margin bars */
@media (max-width: 1600px) {
  :root {
    --page-margin-width: clamp(0px, calc(22vw - 170px), 180px);
  }
  .page-margin-bar {
    width: var(--page-margin-width);
  }
}

/* Hide page margin bars at 1400px */
@media (max-width: 1400px) {
  :root {
    --page-margin-width: 0px;
  }
  .page-margin-bar {
    width: 0;
    display: none;
  }
}

.main-content {
  flex: 1 1;
  background-color: #dbe1e2;
  padding: 20px;
  border-radius: 5px;
  border: 5px solid #ffffff;
  font-family: 'AlternateGot', Arial, sans-serif;
}

.sort-bar {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  color: #676a6a;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 3px solid rgba(172,176,177,255);
  font-family: 'AlternateGot', Arial, sans-serif;
  font-size: 24px;
}

.sort-icon {
  margin-left: 5px;
}

.chapter-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.chapter {
  display: flex;
  padding: 20px 0;
  border-bottom: 2px solid rgba(172,176,177,255);
  cursor: pointer;
  transition: background-color 0.2s;
}

.chapter:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.chapter-image {
  width: 200px;
  height: 275px;
  margin-right: 20px;
}

.chapter-image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  image-rendering: crisp-edges;
  padding: 10px;
}

.chapter-info {
  flex: 1 1;
}

.chapter-title {
  font-size: 52px;
  margin-bottom: 10px;
  color: #323232;
  font-family: 'AlternateGot', Arial, sans-serif;
}

.chapter-date {
  color: #676a6a;
  margin-bottom: 15px;
  font-weight: bold;
  font-family: 'AlternateGot', Arial, sans-serif;
  font-size: 32px;
}

.chapter-description {
  line-height: 1.5;
  color: #676a6a;
  font-family: 'AlternateGot', Arial, sans-serif;
  font-size: 32px;
}

/* Add styles for the chapter link */
.chapter-link {
  text-decoration: none; /* Remove underline */
  color: inherit; /* Inherit text color */
  display: block; /* Make the link take up the chapter div space */
}

.social-links-container {
  background-color: #dbe1e2;
  border: 5px solid #ffffff;
  border-radius: 5px;
  padding: 15px;
  margin-left: 10px;
  align-self: flex-start;
  height: fit-content;
}

.social-links {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.social-link {
  display: inline-flex;
  width: 50px;
  height: 50px;
  border-radius: 5px;
  padding: 5px;
  overflow: hidden;
  transition: filter 0.2s ease, transform 0.2s ease;
}

.social-link:hover,
.social-link:focus-visible {
  filter: brightness(0) invert(1);
  transform: translateY(-2px);
}

.social-icon {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

@media (max-width: 1400px) {
  :root {
    --viewer-bar-width: 0px;
  }

  .app.viewer-active {
    margin: 0;
  }

  .chapter {
    flex-direction: column;
  }

  .chapter-image {
    width: 100%;
    height: auto;
    margin-right: 0;
    margin-bottom: 10px;
  }

  .chapter-info {
    order: 1;
  }

  .social-links-container {
    order: 2;
    margin-left: 0;
    margin-top: 10px;
  }
}

/* Mobile-friendly adjustments for smaller screens */
@media (max-width: 768px) {
  .app {
    padding: 15px;
    padding-top: 140px;
  }

  .main-content {
    padding: 15px;
  }
}

@media (max-width: 480px) {
  .app {
    padding: 10px;
    padding-top: 120px;
  }

  .main-content {
    padding: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/App.css"],"names":[],"mappings":"AAAA,iBAAiB;AACjB;EACE,2BAA2B;EAC3B,+DAA+E;EAC/E,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,+DAA+E;EAC/E,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,+DAA+E;EAC/E,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,kDAAkD;EAClD,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,8CAA8C;EAC9C,eAAe;EACf,yBAAyB;EACzB,yDAA8D;EAC9D,yBAAyB;EACzB,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,yDAAgE;EAChE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA,4BAA4B;AAC5B;EACE,2GAA2G;EAC3G,yBAAyB;EACzB,8CAA8C;EAC9C,kDAAkD;EAClD,+BAA+B;EAC/B,oEAAoE;EACpE,0DAA0D;AAC5D;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,kBAAkB,EAAE,iDAAiD;AACvE;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,aAAa;EACb,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA,+EAA+E;;AAE/E,yDAAyD;;AAEzD,mBAAmB;AACnB;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,SAAS;EACT,8BAA8B;EAC9B,0DAA0D;EAC1D,6CAA6C;EAC7C,WAAW;EACX,oBAAoB;AACtB;;AAEA,2EAA2E;;AAE3E;EACE,OAAO;AACT;;AAEA;EACE,QAAQ;AACV;;AAEA,wCAAwC;AACxC;EACE;IACE,QAAQ;IACR,aAAa;EACf;AACF;;AAEA;;wCAEwC;AACxC;EACE,eAAe;EACf,MAAM;EACN,SAAS;EACT,iEAAiE;EACjE,2CAA2C;EAC3C,0DAA0D;EAC1D,6CAA6C;EAC7C,WAAW;EACX,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,QAAQ;AACV;;AAEA,wCAAwC;AACxC;EACE;IACE,0DAA0D;EAC5D;EACA;IACE,+BAA+B;EACjC;AACF;;AAEA,oCAAoC;AACpC;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,QAAQ;IACR,aAAa;EACf;AACF;;AAEA;EACE,SAAO;EACP,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,8CAA8C;EAC9C,8CAA8C;EAC9C,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8CAA8C;EAC9C,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,4BAA4B;EAC5B,aAAa;AACf;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,8CAA8C;EAC9C,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,8CAA8C;EAC9C,eAAe;AACjB;;AAEA,oCAAoC;AACpC;EACE,qBAAqB,EAAE,qBAAqB;EAC5C,cAAc,EAAE,uBAAuB;EACvC,cAAc,EAAE,gDAAgD;AAClE;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,iDAAiD;AACnD;;AAEA;;EAEE,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;IACR,cAAc;IACd,gBAAgB;EAClB;AACF;;AAEA,oDAAoD;AACpD;EACE;IACE,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["/* Custom Fonts */\n@font-face {\n  font-family: 'AlternateGot';\n  src: url('../assets/site_assets/fonts/AlternateGotNo1D.ttf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'AlternateGot';\n  src: url('../assets/site_assets/fonts/AlternateGotNo2D.ttf') format('truetype');\n  font-weight: bold;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'AlternateGot';\n  src: url('../assets/site_assets/fonts/AlternateGotNo3D.ttf') format('truetype');\n  font-weight: 300;\n  font-style: normal;\n  font-display: swap;\n}\n\n.app.viewer-active .header {\n  justify-content: flex-start;\n  padding-right: 40px;\n}\n\n.app.viewer-active .header.header-compact {\n  padding-left: calc(var(--viewer-bar-width) + 24px);\n  min-height: 80px;\n}\n\n* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\nhtml {\n  scrollbar-gutter: stable;\n}\n\nbody {\n  font-family: 'AlternateGot', Arial, sans-serif;\n  font-size: 18px;\n  background-color: #1a1a1a;\n  background-image: url('../assets/Generic BG Pattern Base.png');\n  background-repeat: repeat;\n  background-size: 250px 250px;\n  color: #fff;\n}\n\nbody.viewer-mode {\n  background-image: url('../assets/site_assets/black_pattern.png');\n  background-repeat: repeat;\n  background-size: 450px, 450px;\n}\n\n/* Shared layout variables */\n:root {\n  /* Responsive margin width: starts at 280px for large screens, scales down with viewport, then disappears */\n  --viewer-bar-width: 350px;\n  --viewer-stage-padding: clamp(16px, 5vw, 64px);\n  /* Breakpoint where margins disappear completely */\n  --margin-collapse-width: 1400px;\n  /* Page margin bar width - very aggressive shrinking with viewport */\n  --page-margin-width: clamp(0px, calc(25vw - 200px), 280px);\n}\n\n.app {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 20px;\n  padding-top: 160px; /* Increased padding between header and content */\n}\n\n.app.viewer-active {\n  max-width: none;\n  width: auto;\n  margin: 0;\n  padding: 0;\n}\n\n.app.viewer-active .container {\n  min-height: 100vh;\n  padding: 0;\n  position: relative;\n  z-index: 60;\n}\n\n.app.viewer-active .content {\n  display: block;\n  margin-top: 0;\n  padding: 0;\n  background: transparent;\n}\n\n.container {\n  display: flex;\n  flex-direction: column;\n}\n\n/* Header styles - removing old conflicting styles as Header.css handles this */\n\n/* Old nav styles removed - using new Header.css styles */\n\n/* Content styles */\n.content {\n  display: flex;\n  margin-top: 20px;\n  position: relative;\n}\n\n.viewer-bar {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  width: var(--viewer-bar-width);\n  background: linear-gradient(180deg, #000 0%, #050505 100%);\n  box-shadow: inset 0 0 30px rgba(0, 0, 0, 0.6);\n  z-index: 40;\n  pointer-events: none;\n}\n\n/* Black bar visibility is now handled by conditional rendering in App.js */\n\n.viewer-bar-left {\n  left: 0;\n}\n\n.viewer-bar-right {\n  right: 0;\n}\n\n/* Hide margins completely below 900px */\n@media (max-width: 900px) {\n  .viewer-bar {\n    width: 0;\n    display: none;\n  }\n}\n\n/* ===================================\n   Page Margin Bars (Non-Viewer Pages)\n   =================================== */\n.page-margin-bar {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  /* Responsive width: starts at 280px, scales down with viewport */\n  width: clamp(0px, calc(15vw - 50px), 280px);\n  background: linear-gradient(180deg, #000 0%, #050505 100%);\n  box-shadow: inset 0 0 30px rgba(0, 0, 0, 0.6);\n  z-index: 40;\n  pointer-events: none;\n  transition: width 0.3s ease;\n}\n\n.page-margin-bar-left {\n  left: 0;\n}\n\n.page-margin-bar-right {\n  right: 0;\n}\n\n/* Responsive behavior for margin bars */\n@media (max-width: 1600px) {\n  :root {\n    --page-margin-width: clamp(0px, calc(22vw - 170px), 180px);\n  }\n  .page-margin-bar {\n    width: var(--page-margin-width);\n  }\n}\n\n/* Hide page margin bars at 1400px */\n@media (max-width: 1400px) {\n  :root {\n    --page-margin-width: 0px;\n  }\n  .page-margin-bar {\n    width: 0;\n    display: none;\n  }\n}\n\n.main-content {\n  flex: 1;\n  background-color: #dbe1e2;\n  padding: 20px;\n  border-radius: 5px;\n  border: 5px solid #ffffff;\n  font-family: 'AlternateGot', Arial, sans-serif;\n}\n\n.sort-bar {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  color: #676a6a;\n  margin-bottom: 20px;\n  padding-bottom: 10px;\n  border-bottom: 3px solid rgba(172,176,177,255);\n  font-family: 'AlternateGot', Arial, sans-serif;\n  font-size: 24px;\n}\n\n.sort-icon {\n  margin-left: 5px;\n}\n\n.chapter-list {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.chapter {\n  display: flex;\n  padding: 20px 0;\n  border-bottom: 2px solid rgba(172,176,177,255);\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.chapter:hover {\n  background-color: rgba(0, 0, 0, 0.05);\n}\n\n.chapter-image {\n  width: 200px;\n  height: 275px;\n  margin-right: 20px;\n}\n\n.chapter-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  image-rendering: crisp-edges;\n  padding: 10px;\n}\n\n.chapter-info {\n  flex: 1;\n}\n\n.chapter-title {\n  font-size: 52px;\n  margin-bottom: 10px;\n  color: #323232;\n  font-family: 'AlternateGot', Arial, sans-serif;\n}\n\n.chapter-date {\n  color: #676a6a;\n  margin-bottom: 15px;\n  font-weight: bold;\n  font-family: 'AlternateGot', Arial, sans-serif;\n  font-size: 32px;\n}\n\n.chapter-description {\n  line-height: 1.5;\n  color: #676a6a;\n  font-family: 'AlternateGot', Arial, sans-serif;\n  font-size: 32px;\n}\n\n/* Add styles for the chapter link */\n.chapter-link {\n  text-decoration: none; /* Remove underline */\n  color: inherit; /* Inherit text color */\n  display: block; /* Make the link take up the chapter div space */\n}\n\n.social-links-container {\n  background-color: #dbe1e2;\n  border: 5px solid #ffffff;\n  border-radius: 5px;\n  padding: 15px;\n  margin-left: 10px;\n  align-self: flex-start;\n  height: fit-content;\n}\n\n.social-links {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.social-link {\n  display: inline-flex;\n  width: 50px;\n  height: 50px;\n  border-radius: 5px;\n  padding: 5px;\n  overflow: hidden;\n  transition: filter 0.2s ease, transform 0.2s ease;\n}\n\n.social-link:hover,\n.social-link:focus-visible {\n  filter: brightness(0) invert(1);\n  transform: translateY(-2px);\n}\n\n.social-icon {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  display: block;\n}\n\n@media (max-width: 1400px) {\n  :root {\n    --viewer-bar-width: 0px;\n  }\n\n  .app.viewer-active {\n    margin: 0;\n  }\n\n  .chapter {\n    flex-direction: column;\n  }\n\n  .chapter-image {\n    width: 100%;\n    height: auto;\n    margin-right: 0;\n    margin-bottom: 10px;\n  }\n\n  .chapter-info {\n    order: 1;\n  }\n\n  .social-links-container {\n    order: 2;\n    margin-left: 0;\n    margin-top: 10px;\n  }\n}\n\n/* Mobile-friendly adjustments for smaller screens */\n@media (max-width: 768px) {\n  .app {\n    padding: 15px;\n    padding-top: 140px;\n  }\n\n  .main-content {\n    padding: 15px;\n  }\n}\n\n@media (max-width: 480px) {\n  .app {\n    padding: 10px;\n    padding-top: 120px;\n  }\n\n  .main-content {\n    padding: 12px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
